import { render, staticRenderFns } from "./ApplianceTypeSelect.vue?vue&type=template&id=166def4c"
import script from "./ApplianceTypeSelect.vue?vue&type=script&lang=js"
export * from "./ApplianceTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports